export enum EnterpriseTourStep {
  CREATE_DEVELOPMENT_INSTANCE = 'CREATE_DEVELOPMENT_INSTANCE',
  DEFINE_WORKFLOW = 'DEFINE_WORKFLOW'
}
